// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "video".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { graphicUsageTypeValues, videoProcessingStageValues, videoStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "video" table (1:1 with a DB row, on the wire). */
export const videoAtomSchema = z.object({
    id: z.string(),
    title: z.string(),
    status: z.enum(videoStatusValues),
    errorMessage: z.string().nullable(),
    progress: z.number().nullable(),
    usageType: z.enum(graphicUsageTypeValues),
    processingStage: z.enum(videoProcessingStageValues).nullable(),
    stageStartedAt: z.string().datetime().nullable(),
    draftConfig: z.unknown().nullable(),
    schemaVersion: z.number(),
    renderDoc: z.unknown().nullable(),
    synthesisOverrides: z.unknown().nullable(),
    synthesisSeed: z.number().nullable(),
    blobUrl: z.string().nullable(),
    thumbnailUrl: z.string().nullable(),
    durationMs: z.number().nullable(),
    templateId: z.string().nullable(),
    variationId: z.string().nullable(),
    serviceId: z.string().nullable(),
    offerId: z.string().nullable(),
    organizationId: z.string(),
    createdById: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
    exportedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=video.js.map